module.exports = __webpack_public_path__ + "static/media/dual-key.039c4e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/dual-key.png
// module id = 1181
// module chunks = 0